// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.v-application--wrap[data-v-7ba5bd90] {\r\n  height: 100vh !important;\n}\nhtml[data-v-7ba5bd90] {\r\n  overflow-y: auto;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
